/* Home "Mix & Match" row (Arjun 16-10: "Single postersலயும் எல்லா layoutsம் வர்ற மாதிரி வை ... layouts மட்டும்").
   A copy of assets/pz-home-byw.js rooted on the M&M row (.pz-home-mm, walls from assets/pz-mm-looks.json): posters land on the
   pack's sheets one by one, the wall changes every 3 s, every cycle ends on an empty turn, only cards on screen move, it stops
   after 24 switches. The difference: the card link carries the posters on screen (&pick=handle,...), so a tap opens the
   Mix & Match builder on that pack with those posters already in (pz-wall-builder.js ?start= + ?pick=); the empty turn drops it. */
(function () {
  var root = document.querySelector('.pz-home-mm[data-looks]');
  if (!root || root.__pzmm) return;
  root.__pzmm = 1;
  var MS = 3000, MAX = 24, ticks = 0, idx = {}, cur = {}, seen = {}, LOOKS = null, io = null, calm = false;
  try { calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function thumb(s, w) { return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cardOf(pic) {
    var key = pic.getAttribute('data-key'), spots = Array.prototype.slice.call(pic.querySelectorAll(':scope > i.pz-glk'));
    if (!key || !LOOKS || !LOOKS[key] || !LOOKS[key].length || !spots.length) return null;
    return { key: key, mini: pic, spots: spots, pk: pic.closest('.pk') };
  }
  function setLinks(c, n) {
    if (!c.pk) return;
    var lk = n >= 0 && LOOKS && LOOKS[c.key] ? LOOKS[c.key][n] : null;
    var picks = lk && lk.items ? lk.items.map(function (it) { return it.handle; }).filter(Boolean).join(',') : '';
    Array.prototype.forEach.call(c.pk.querySelectorAll('a[href]'), function (a) {
      var h = a.getAttribute('href').replace(/([?&])pick=[^&]*(&|$)/, function (m, p1, p2) { return p2 ? p1 : ''; }).replace(/[?&]$/, '');
      a.setAttribute('href', picks ? h + (h.indexOf('?') > -1 ? '&' : '?') + 'pick=' + picks : h);
    });
  }
  function show(c, animate) {
    var looks = LOOKS[c.key], L = looks.length, n = idx[c.key] || 0, slot = n % (L + 1);
    c.mini.setAttribute('data-pzlk', '1');
    var oldLab = c.mini.querySelector('.pz-lk-yours');
    if (slot === L) {   /* the empty turn */
      cur[c.key] = -1; setLinks(c, -1);
      c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); });
      var bx0 = Infinity, by0 = Infinity, bx1 = 0, by1 = 0;
      var ordE = c.spots.map(function (el, i) {
        bx0 = Math.min(bx0, el.offsetLeft); by0 = Math.min(by0, el.offsetTop);
        bx1 = Math.max(bx1, el.offsetLeft + el.offsetWidth); by1 = Math.max(by1, el.offsetTop + el.offsetHeight);
        return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft };
      }).sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
      var stepE = Math.min(90, Math.floor(1200 / Math.max(1, c.spots.length)));
      setTimeout(function () {
        ordE.forEach(function (o, k) { var el = c.spots[o.i]; el.style.setProperty('--pzd', (animate ? k * stepE : 0) + 'ms'); el.classList.add('pz-lk-blank'); });
        if (oldLab && oldLab.parentNode) oldLab.parentNode.removeChild(oldLab);
        var lab = document.createElement('span');
        lab.className = 'pz-lk-yours';
        lab.textContent = 'Choose any poster';
        if (bx1 > bx0) { lab.style.left = ((bx0 + bx1) / 2) + 'px'; lab.style.top = ((by0 + by1) / 2) + 'px'; }
        c.mini.appendChild(lab);
      }, animate ? 260 : 0);
      looks[0].items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
      return;
    }
    var lk = looks[slot];
    if (!lk || !lk.items || lk.items.length !== c.spots.length) return;
    cur[c.key] = slot; setLinks(c, slot);
    if (oldLab && oldLab.parentNode) oldLab.parentNode.removeChild(oldLab);
    c.spots.forEach(function (el) { el.classList.remove('pz-lk-blank'); });
    var order = c.spots.map(function (el, i) { return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft }; })
      .sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
    var step = Math.min(110, Math.floor(1600 / Math.max(1, c.spots.length)));
    var put = function () {
      order.forEach(function (o, k) {
        var el = c.spots[o.i], it = lk.items[o.i], im = el.querySelector('img.pz-lk');
        if (!im) { im = document.createElement('img'); im.className = 'pz-lk'; im.alt = ''; im.decoding = 'async'; el.appendChild(im); }
        im.src = thumb(it.img, 160);
        el.style.setProperty('--pzd', (animate ? k * step : 0) + 'ms');
      });
      void c.mini.offsetWidth;   /* a forced layout starts the transitions (rAF stalls in a background tab) */
      c.spots.forEach(function (el) { el.classList.add('pz-lk-on'); });
    };
    var was = c.spots[0].classList.contains('pz-lk-on');
    if (was && animate) { c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); }); setTimeout(put, 260); }
    else put();
    var nx = looks[slot + 1];
    if (nx && nx.items) nx.items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
  }
  function tick() {
    if (!LOOKS || document.hidden) return;
    var pics = root.querySelectorAll('.pz-hb-pic[data-key]');
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.__pzVis = e.isIntersecting; }); }, { threshold: 0.35 });
    }
    var moved = false;
    Array.prototype.forEach.call(pics, function (pic, ci) {
      if (io && !pic.__pzObs) { pic.__pzObs = 1; io.observe(pic); }
      var c = cardOf(pic); if (!c) return;
      /* 15-10 ("First 3 sec ku poster varla"): the first wall comes baked into the HTML (data-lk = its look); carry on from it */
      if (!seen[c.key] && pic.getAttribute('data-lk') != null && pic.querySelector('i.pz-lk-on')) {
        idx[c.key] = +pic.getAttribute('data-lk') || 0; cur[c.key] = idx[c.key]; setLinks(c, idx[c.key]); seen[c.key] = 1; return;
      }
      if (!pic.getAttribute('data-pzlk')) {
        if (!seen[c.key]) idx[c.key] = ci % LOOKS[c.key].length;
        show(c, !calm); seen[c.key] = 1; return;
      }
      if (calm || (io && !pic.__pzVis)) return;
      if (ticks >= MAX) {
        if (cur[c.key] === -1) { idx[c.key] = (idx[c.key] || 0) + 1; show(c, true); }
        return;
      }
      idx[c.key] = (idx[c.key] || 0) + 1; show(c, true); moved = true;
    });
    if (moved) ticks++;
  }
  function boot() {
    var x = new XMLHttpRequest();
    x.open('GET', root.getAttribute('data-looks'), true);
    x.timeout = 10000;
    x.onload = function () {
      var j = null;
      try { j = JSON.parse(x.responseText); } catch (e) {}
      if (x.status !== 200 || !j || !j.looks) return;
      LOOKS = j.looks;
      tick();
      setInterval(tick, MS);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    };
    x.send();
  }
  /* the walls list (the builder's own file, brotli on the CDN) is asked for at once - the cards already show their first
     wall from the HTML, so this only feeds the next ones (15-10: waiting for window load left the sheets empty ~3 s) */
  boot();
})();
